module.exports = __webpack_public_path__ + "img/login2.1c071041.jpg";